import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";

export const publicationsApi = {
    get: () => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.GetPublication();
        const request = client.get(query);
        return Observable.from(request);
    },
    upsert: (publication: CreDtos.Publication) => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.PostPublication();
        query.publication = publication;
        const request = client.post(query);
        return Observable.from(request);
    }
};




// WEBPACK FOOTER //
// ./src/services/publications.service.ts